export default "__VITE_ASSET__M95jD7ok__"